module.exports = __webpack_public_path__ + "static/media/loader.62ac884f.svg";